import { CommonEnums } from "../../enums/common.enums";
import { EnvVariables } from "../../enums/env.variables.enums";

export class CommonHelpers {
  static isAgentRoute = (params: { path: string }) => {
    if (params.path.includes(CommonEnums.roles.agent)) return true;
    return false;
  };

  static isAgencyRoute = (params: { path: string }) => {
    if (params.path.includes(CommonEnums.roles.agency)) return true;
    return false;
  };

  static getImageUrlFromImageTool = (params: { path: string }) => {
    return `${EnvVariables.designToolEndpoint}/design-tool/images/${params.path}`;
  };

  static getPropertyAddress = ({
    unit,
    no,
    streetName,
    city,
    state,
    country,
    postCode,
  }: {
    unit?: string;
    no: string;
    streetName: string;
    city: string;
    state: string;
    country: string;
    postCode: string;
  }) => {
    let address = `${streetName}, ${city}, ${state}, ${postCode}`;

    const unitStr = unit ? unit.toString().trim() : "";
    const numberStr = no ? no.toString().trim() : "";

    if (unitStr && numberStr) {
      address = `${unitStr}/${numberStr} ${address}`;
    } else if (numberStr) {
      address = `${numberStr} ${address}`;
    } else if (unitStr) {
      address = `${unitStr} ${address}`;
    }

    return address;
  };
}
